<template>
  <div>
    <van-popup
      v-model="popupShow"
      position="bottom"
      :style="{ height: '85%' }"
    >
      <form action="/">
        <van-search
          v-model="searchKeyword"
          :show-action="false"
          placeholder="请输入私房课标题关键词"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form>
      <episode-list
        slug="sanhao"
        :editorChoiceOnly="false"
        :premiumOnly="true"
        :episode-ids="episodeIds"
        :limit="0"
        :voucher-id="voucherCardData.id"
        @voucher-update-success="voucherUpdateSuccess"
      />
    </van-popup>
    <div class="container">
      <div class="inner-container">
        <van-row type="flex" justify="space-between" align="center">
          <van-col span="24">
            <div class="title">
              私房课兑换券
              <van-tag
                v-if="voucherCardData.episode"
                type="success"
                plain
                style="float:right;"
              >已兑换</van-tag>
            </div>
            <div class="code">{{voucherCardData.code}}</div>
          </van-col>
          <!-- <van-col
            span="8"
            style="text-align:right"
          >
            <van-icon name="coupon-o" size='3rem' />
          </van-col> -->
        </van-row>
        <div class="notice">
          <p v-html="voucherConfig.description"></p>
          <!-- <ol>
            <li>1. 每购买4张礼品卡，可获得1张兑换券</li>
            <li>2. 每张兑换券可免费兑换一期私房课节目</li>
            <li>3. 兑换券不可转让</li>
          </ol> -->
        </div>
        <van-divider dashed :style="{ borderColor: '#999', marginBottom: '15px', marginTop: '5px' }" />
        <div class="progress">
          <van-row type="flex" justify="space-between" align="center">
            <van-col v-if="!canRedeem" span="24" style="margin:5px 0;">
              <van-progress
                :percentage="percentage"
                inactive
                :pivot-text="giftcardsCount"
              />
            </van-col>
            <van-col
              v-if="canRedeem"
              span="24"
            >
              <div
                v-if="voucherCardData.episode"
              >
                <van-button
                  type="default"
                  size="small"
                  icon="play-circle-o"
                  :block="true"
                  :disabled="false"
                  @click="navigateToEpisode"
                >
                  {{episode.title}}
                </van-button>
              </div>
              <van-button
                v-else
                type="primary"
                size="small"
                :block="true"
                :disabled="false"
                @click="redeem"
              >兑换</van-button>
              <!-- <van-button
                v-else
                type="default"
                size="mini"
                :disabled="true"
              >不可兑换</van-button> -->
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EpisodeList from '../../episode-list.vue'
  import Vue from 'vue'
  import { Col, Row } from 'vant'
  import { Divider } from 'vant'
  import { Button } from 'vant'
  import { Progress } from 'vant'
  import { Popup } from 'vant'
  import { Search } from 'vant'
  import { Icon } from 'vant'
  import { Toast } from 'vant'
  Vue.use(Col)
  Vue.use(Row)
  Vue.use(Divider)
  Vue.use(Button)
  Vue.use(Progress)
  Vue.use(Popup)
  Vue.use(Search)
  Vue.use(Icon)
  Vue.use(Toast)
  // Vue.forceUpdate()

  export default {
    name: "voucher-card-detail",
    components: {
      EpisodeList
    },
    props: {
      listMode: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        required: false
      },
      voucherCardData: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        loading: false,
        episode: {
          title: ''
        },
        popupShow: false,
        searchKeyword: '',
        episodeIds: [],
        voucherConfig: {
          description: ''
        }
      }
    },
    computed: {
      percentage () {
        let percentage
        const giftcardsRequired = 4 // 需要购买几张礼品卡
        if (this.voucherCardData) {
          if (this.voucherCardData.contributions.giftcards) {
            percentage = (this.voucherCardData.contributions.giftcards.length / giftcardsRequired) * 100
          } else {
            percentage = (1 / giftcardsRequired) * 100
          }
        } else {
          percentage = (1 / giftcardsRequired) * 100
        }
        return percentage
      },
      giftcardsCount () {
        let count
        if (this.voucherCardData) {
          if (this.voucherCardData.contributions.giftcards) {
            count = this.voucherCardData.contributions.giftcards.length
          } else {
            count = 1
          }
        } else {
          count = 1
        }
        return `已购${count}张`
      },
      canRedeem () {
        let canRedeem
        const giftcardsRequired = 4 // 需要购买几张礼品卡
        if (this.voucherCardData) {
          if (this.voucherCardData.contributions.giftcards) {
            if (this.voucherCardData.contributions.giftcards.length >= giftcardsRequired) {
              canRedeem = true
            } else {
              canRedeem = false
            }
          } else {
            canRedeem = false
          }
        }
        return canRedeem
      }
    },
    methods: {
      onSearch: function (keyword) {
        window.console.log("Start Searching...", keyword)
        Toast.loading({
          message: '正在搜索...',
          forbidClick: true,
          duration: 0
        })
        let params = {
          show__slug: 'sanhao'
        }
        if (keyword) {
          params.search = keyword
        }
        this.$api.episode.list(params)
        .then(res => {
          window.console.log("获取指定 EPISODE LIST 成功", res.data)
          Toast.clear()
          if (res.data.count > 0) {
            let episodeIds = []
            const results = res.data.results
            for (let i = 0; i < results.length; i++) {
              const element = results[i];
              episodeIds.push(element.id)
            }
            this.episodeIds = episodeIds
            Toast.success({
              message: `${res.data.count}节私房课`,
              forbidClick: true,
              duration: 2500
            })
          } else {
            Toast.fail({
              message: '无相关私房课',
              forbidClick: true,
              duration: 2500
            })
          }
        })
        .catch(err => {
          window.console.log('error', err)
        })
      },
      onCancel: function () {

      },
      redeem: function () {
        window.console.log("REDEEM")
        this.popupShow = true
      },
      voucherUpdateSuccess: function () {
        window.console.log("收到 Voucher 更新成功事件通知3")
        this.popupShow = false
        this.$emit('voucher-update-success', {
          voucherId: this.voucherCardData.id
        })
      },
      navigateToEpisode: function () {
        // window.console.log("navigateToEpisode", this.voucherCardData.episode)
        this.$router.replace({
          name: 'EpisodeDetail',
          params: {
            episodeId: this.voucherCardData.episode
          }
        })
      },
      getVoucherConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.voucherConfig.list(params)
        .then(res => {
          window.console.log("获取到 voucher config")
          window.console.log(res)
          if (res.data.count > 0) {
            that.voucherConfig = res.data.results[0]
          } else {
            window.console.log("未找到相关配置")
          }
        })
        .catch(err => {
          window.console.log("获取 voucher config 有误", err)
        })
      }
    },
    watch: {
      'voucherCardData.episode': {
        immediate: true,
        handler: function (episodeId) {
          if (episodeId) {
            let that = this
            that.$api.episode.detail(episodeId).then(res => {
              window.console.log("已获取 Episode")
              window.console.log(res.data)
              that.episode = res.data
            })
          }
        }
      }
    },
    mounted () {
      this.getVoucherConfig()
    }
  }
</script>

<style lang="css" scoped>
.inner-container {
  /* background: #efefef; */
  background: #fff;
  /* padding: 8px 12px; */
  padding: 10px;
  padding-bottom: 15px;
  border-radius: 5px;
  border: 1px solid #ebedf0;
}
.title {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  margin-left: 0;
  padding-left: 0;
}
.code {
  font-size: 11px;
  line-height: 1;
  margin-top: 6px;
  width: 70vw;
  overflow: hidden;
  color: #bbb;
}
.notice{
  font-size: 11px;
  line-height: 1.3;
  margin: 10px 0 15px 0;
}
</style>
